// Starting a league's next season (PLAN-2026-10-27-the-next-season §2.1, §4;
// scenario H6).

import { z } from 'zod';

/**
 * `POST /api/leagues/:id/next-season`: how the next season goes on from this
 * one, chosen as it starts (§2.1 rule 5): everyone starting fresh, each team
 * keeping a few, or every roster kept. A keeper league says how many each
 * team keeps when the league kept nobody before; otherwise it keeps last
 * season's count. The answer is the new season's league, 201.
 */
export const NextSeasonRequest = z.object({
  format: z.enum(['redraft', 'keeper', 'dynasty']),
  keeperCount: z.number().int().min(1).max(40).optional(),
});
export type NextSeasonRequest = z.infer<typeof NextSeasonRequest>;
